import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { routerReducer } from 'react-router-redux'
import { routerMiddleware, connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'

// reducers
import coreReducer from './slices/core'
import userReducer from './slices/user'
import breadcrumbsReducer from './slices/breadcrumbs'
import authAccountReducer from './slices/authAccount'
import organizationReducer from './slices/organization'
import opportunitiesReducer from './slices/opportunities'
import teamReducer from './slices/team'
import matchRequestReducer from './slices/matchRequest'
import locationsReducer from './slices/locations'
import loadingReducer from './slices/loading'
import programsReducer from './slices/programs'
import fundraisingReducer from './slices/fundraising'
import templatesReducer from './slices/templates'
import calendarReducer from './slices/calendar'
 
export const history = createBrowserHistory()

export const store = configureStore({
    reducer: {
        core: coreReducer,
        user: userReducer,
        breadcrumbs: breadcrumbsReducer,
        authAccount: authAccountReducer,
        organization: organizationReducer,
        programs: programsReducer,
        opportunities: opportunitiesReducer,
        team: teamReducer,
        matchRequest: matchRequestReducer,
        locations: locationsReducer,
        loading: loadingReducer,
        fundraising: fundraisingReducer,
        templates: templatesReducer,
        calendar: calendarReducer,
        router: connectRouter(history)
    },
    middleware: (getDefaultMiddleware: any) => getDefaultMiddleware().concat(routerMiddleware(history))
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export const useAppDispatch = () => useDispatch<AppDispatch>()

export default store